<style src="./ItemAssociation.scss" lang="scss" scoped></style>
<template>
  <section class="quote">
    <content-header />

    <section class="main-container row">
      <section class="quote-container col-12">
        <top-bar />
      </section>
    </section>

    <section class="main-container row">
      <section class="quote-container col-xg-12 col-xxg-9">
        <product-finder />
      </section>

      <section class="panel-container hide-xg col-xxg-3">
        <quote-status />
        <quote-map />
      </section>
    </section>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import { TopBar, ProductFinder, EventInfo, QuoteStatus, QuoteMap } from './components'

export default {
  name: 'ItemAssociation',
  components: {
    ContentHeader,
    TopBar,
    ProductFinder,
    EventInfo,
    QuoteStatus,
    QuoteMap
  },
  mounted () {
    const eventId = this.$route.params.id
    if (!eventId) return false
    this.$store.dispatch('ItemAssociation/LOAD_EVENT', { eventId })
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/ItemAssociation.vue